import { links } from "../content/profile";
import type { AnalyticsSummary } from "../types";

const today = new Date();

function dayOffset(offset: number): string {
  const date = new Date(today);
  date.setDate(today.getDate() - offset);
  return date.toISOString().slice(0, 10);
}

export function getMockAnalyticsSummary(days = 30): AnalyticsSummary {
  const daily = Array.from({ length: Math.min(days, 14) }, (_, index) => {
    const reverseIndex = Math.min(days, 14) - index - 1;
    return {
      day: dayOffset(reverseIndex),
      views: 28 + index * 4 + (index % 3) * 7,
      clicks: 11 + index * 2 + (index % 4) * 3,
      shares: index % 5
    };
  });

  const views = daily.reduce((sum, row) => sum + row.views, 0);
  const clicks = daily.reduce((sum, row) => sum + row.clicks, 0);
  const shares = daily.reduce((sum, row) => sum + row.shares, 0);

  return {
    source: "mock",
    rangeDays: days,
    generatedAt: new Date().toISOString(),
    totals: {
      views,
      clicks,
      shares,
      uniqueVisitors: Math.round(views * 0.67),
      clickThroughRate: views ? clicks / views : 0
    },
    links: links.map((link, index) => ({
      id: link.id,
      slug: link.slug,
      title: link.title,
      url: link.url,
      clicks: Math.max(9, Math.round(clicks / (index + 2))),
      shares: index === 0 ? 7 : index,
      ctr: views ? Math.max(0.04, Math.round((clicks / (index + 3) / views) * 100) / 100) : 0
    })),
    daily,
    referrers: [
      { label: "instagram.com", count: Math.round(views * 0.38) },
      { label: "tiktok.com", count: Math.round(views * 0.25) },
      { label: "direct", count: Math.round(views * 0.22) },
      { label: "shopee.vn", count: Math.round(views * 0.08) }
    ],
    countries: [
      { label: "VN", count: Math.round(views * 0.72) },
      { label: "AU", count: Math.round(views * 0.11) },
      { label: "US", count: Math.round(views * 0.07) }
    ],
    devices: [
      { label: "mobile", count: Math.round(views * 0.82) },
      { label: "desktop", count: Math.round(views * 0.14) },
      { label: "tablet", count: Math.round(views * 0.04) }
    ],
    recentEvents: []
  };
}
